const defaultContent = `Pearson Fuels Celebrates 450 E85 Stations Across California

Cleaner, more affordable fuel now within reach for millions of drivers

Across California, Pearson Fuels's growing network ensures that drivers are never far from a station offering cleaner, domestically produced fuel. The expansion comes at a time when California drivers are increasingly turning to alternatives that cut both emissions and costs.

“Every new location means more Californians can take part in the state's transition to cleaner transportation,” said Greg Jones, director of business development at Pearson Fuels. “We’re seeing drivers choose E85 not just because it’s better for the environment, but because it’s consistently more affordable than gasoline—often by $1.50 or more per gallon.”

About Pearson Fuels

Founded in San Diego, Pearson Fuels is California's leading distributor of E85 flex fuel. With a mission to make clean, renewable fuels accessible to everyone, Pearson Fuels partners with retail stations statewide to deliver high-quality, low-carbon E85 that helps drivers save money and reduce their environmental impact.

Learn more and find E85 near you by downloading the Pearson Fuels App or visiting www.PearsonFuels.com.`;
export default defaultContent;
